import { render, staticRenderFns } from "./NewGifSelector.vue?vue&type=template&id=229bfc01&"
import script from "./NewGifSelector.vue?vue&type=script&lang=js&"
export * from "./NewGifSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports